import { defineStore } from "pinia";

import { ref, computed } from 'vue'

import axios from 'axios'

export const useUploadStore = defineStore('useUploadStore', () => {

  const selectedFiles = ref([]);

  const errorMsg = ref("");

  const isRunning = ref(false);

  const isUploading = computed(() =>
    selectedFiles.value.some((file) => file.status == "uploading")

  );

  const pending_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "pending").length

  );

  const failed_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "failed").length

  );

  const success_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "success").length

  );

  const onSelectFiles = (event) => {
    const target = event.target;
    if (target.files === null) {
      return;
    }

    clearFiles();

    const files = Array.from(target.files);
    const validFiles = files.filter((file) => {
      const fileName = file.name.toLowerCase();
      return fileName.endsWith(".jpg") || fileName.endsWith(".jpeg");
    });
    const invalidFiles = files.filter((file) => {
      const fileName = file.name.toLowerCase();
      return !fileName.endsWith(".jpg") && !fileName.endsWith(".jpeg");
    });

    if (invalidFiles.length > 0) {
      alert("อนุญาตให้อัปโหลดเฉพาะไฟล์ .jpg และ .jpeg เท่านั้น");
    }

    validFiles.forEach((file) => {
      selectedFiles.value.push({
        file: file,
        percentage: 0,
        status: "pending",
      });
    });

    if (validFiles.length === 0) {
      target.value = null;
    }
  };

  const clearFiles = () => {
    selectedFiles.value = []
    errorMsg.value = ""
  };

  const uploadFile = ( file, onUploadProgress, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment) => {

     if(Number(file.size/10000).toFixed(0) < Number(35)){
       return new Promise((resolve, reject) => {
          errorMsg.value = "***ขนาดไฟล์ต้องไม่ต่ำกว่า 350KB"
          reject("ขนาดไฟล์ต้องไม่ต่ำกว่า 350KB");
        });
      
    }
    return axios.post("v1/upload/reserve", {
      event_id: event_id,
      photographer_id: user_id,
      original_file_name: file.name,
      event_key: event_key,
      event_stage: event_stage,
      is_hybrid: is_hybrid,
      is_mhao_hybrid: is_mhao_hybrid
    })
    .then((reserve_response) => {
      const data = reserve_response.data;
      if(data.status === 'skip'){
        return "skip"
      }
      if(data.status !== 'ok'){
        // busy / failed -> mark failed so the file can be retried
        return Promise.reject(data.status || "reserve_failed");
      }
      const image_id = data.image_id;
      return axios.put(data.url, file, {
        headers: {
          "Content-Type": "image/jpg",
          "Content-Disposition": `inline; filename="${data.upload_file_name}"`,
        },
        onUploadProgress,
      })
      .then((put_response) => {
        if(put_response.status === 200){
          return axios.post("v1/upload/commit", {
            image_id: image_id,
            event_id: event_id,
            photographer_id: user_id,
            event_key: event_key,
            upload_file_name: data.upload_file_name,
            preview_file_name: data.preview_file_name,
            thumbnail_file_name: data.thumbnail_file_name,
            event_watermark_hori: event_watermark_hori,
            event_watermark_vertical: event_watermark_vertical,
            is_free_download: is_free_download,
            is_add_watermark_for_free_download: is_add_watermark_for_free_download,
            is_image_addjustment: is_image_addjustment
          });
        }
        return Promise.reject("put_failed");
      })
      .catch((err) => {
        // rollback the reserved row so a retry can reserve it again
        return axios.post("v1/upload/rollback", { image_id: image_id })
          .catch(() => {})
          .then(() => Promise.reject(err));
      });
    });
  };

  const sleep_only = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      },20)
    });
  }

  const sleep_upload_slow_upload = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      }, 500)
    });
  }

  const sleep_upload_slow_upload_api = async () => {
    return new Promise((resolve, reject) => {
        return axios.get("https://yjdxyhjl7eirggm42hjju74ze40nfxyx.lambda-url.ap-southeast-1.on.aws", null,)
        .then((response) => {
          resolve(true)       
        });
    });
  }

  const call_upload_file = ( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment) => {

    return new Promise((resolve, reject) => {
      file.status = "uploading";
      file.percentage = 0;
      uploadFile( file.file, (event) => {
        file.percentage = Math.round((100 * event.loaded) / event.total);
      }, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment)
        .then((response) => {
          file.status = "success";
          resolve(true)
        })
        .catch(() => {
          file.status = "failed";
          resolve(false)
        });
    });
  }

  const uploadSelectedFiles = async (event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,
    server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,credit_balance,is_image_addjustment) => {

    if(isRunning.value){
      return;
    }

    if(is_hybrid === 'Y' && is_mhao_hybrid === 'N'){
      let check_pending = selectedFiles.value.filter(file => file.status == "pending").length 
      if(check_pending > credit_balance){
        alert("เครดิตสำหรับการ upload ไม่เพียงพอกรุณาเติมเครดิต")
        return false;
      }
    }
    let check_success = selectedFiles.value.filter(file => file.status == "success").length
    if (check_success === selectedFiles.value.length) {
      if(check_success===0){
        alert("Please choose file befor upload")
      }else{
        alert("All files uploaded")
      }
    }else if(is_event_stage === 'Y' && event_stage===0){
      alert("Please choose stages,location befor upload")
    } else {
      isRunning.value = true;
      try {
        const promises = [];
        let counter = 0;
        let array_size = selectedFiles.value.length;
        let thead_upload = 10;
        while (counter < array_size) {
          let _uploading_count = selectedFiles.value.filter(file => file.status == "uploading").length
          if(_uploading_count <= thead_upload){
            let file = selectedFiles.value[counter];
            if(file.status === 'pending' || file.status === 'failed'){
              promises.push(call_upload_file( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment))
            }
            counter++
          }else{
            await sleep_upload_slow_upload_api();
          }
        }
        await Promise.all(promises);
      } finally {
        isRunning.value = false;
      }
    }
  }

  return { selectedFiles, isUploading, isRunning, pending_count,  failed_count, success_count, onSelectFiles, clearFiles, uploadSelectedFiles, errorMsg }
});